module.exports = __webpack_public_path__ + "img/hone-solution4.5cbee2cf.png";